import { subscribe } from "@shared/utils.events";
import { useSegment } from "./useSegment";

interface ProductClicked {
  currency: string;
  membersPrice: number;
  name: string;
  sku: string;
  typicalPrice: number;
  url: string;
  brand: string;
  variant: string;
  locationDetails?: string;
}

interface ProductListViewed {
  currency: string;
  productCategory1: string;
  productPriceType: "Member Price" | "Typical Price";
  products: { sku: string }[];
  productCategory2?: string;
  productCategory3?: string;
  location?: string;
  locationDetails?: string;
}

export const useProductEvents = (): (() => void) => {
  const { track } = useSegment();

  return () => {
    subscribe("productClicked", (payload) => {
      const {
        currency,
        membersPrice,
        name,
        sku,
        typicalPrice,
        url,
        brand,
        variant,
        locationDetails
      } = payload as unknown as ProductClicked;
      track({
        event: "Product Clicked",
        properties: {
          currency,
          members_price: membersPrice,
          name,
          sku,
          typical_price: typicalPrice,
          url,
          brand,
          variant,
          location_type_details: locationDetails
        }
      });
    });
    subscribe("productListViewed", (payload) => {
      const {
        currency,
        productCategory1,
        productPriceType,
        products,
        productCategory2,
        productCategory3,
        location,
        locationDetails
      } = payload as unknown as ProductListViewed;
      track({
        event: "Product List Viewed",
        properties: {
          currency,
          product_category_1: productCategory1,
          product_price_type: productPriceType,
          products,
          product_category_2: productCategory2,
          product_category_3: productCategory3,
          location_type: location,
          location_type_details: locationDetails
        }
      });
    });
  };

  //add product added event
};
